import template from './benefitRequestList.html';
import controller from './benefitRequestList.controller';
import './benefitRequestList.scss';

let benefitRequestListComponent = {
  restrict: 'E',
  bindings: {
    isMobileApp: '<',
    periods: '<',
    isRequestOk: '<',
    requestDataUpdate: '&',
    hasDelegations : '<',
  },
  template,
  controller,
};

export default benefitRequestListComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestList/benefitRequestList.component.js